import {
  Component,
  EventEmitter,
  Output,
  Input,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  API_URL_GET_DETAIL_EVALUATION
} from "manager/http-constants";
import { MESSAGE_CODE } from "src/app/shared/constant/message-constant";
import { TOAST } from "src/app/shared/constant/primeng-constants";
import {
  LoadingState,
} from "src/app/shared/html-parts/loading/loading-state";
import {
  MessageData,
  ToastMessageData,
} from "src/app/shared/html-parts/message-common/message-data";
import { CommonService } from "src/app/shared/service/common.service";
import { DbOperationService } from "src/app/shared/service/db-operation.service";
import { PlatformComponent } from "../../platform.component";
import { LoginService } from "src/app/shared/service/login.service";

@Component({
  selector: "app-evaluation-dialog",
  templateUrl: "./evaluation-dialog.component.html",
  styleUrls: ["./evaluation-dialog.component.scss"],
})

/**
 * 共通部品_承認時ダイアログ
 */
export class EvaluationDialogComponent extends PlatformComponent {
  @Output() returnStatusDialog = new EventEmitter<boolean>();
  @Output() reload = new EventEmitter<null>();
  @Input() matchId: string;
  @Input() reportId: string;
  @Input() spoofId: string;

  boardFlag: boolean = false;
  roleValue: string;

  data: any[] = [];
  class_id: any = '';

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private messageData: MessageData,
    public loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState, loginService);
  }

  ngOnInit(): void {
    this.getUserLoginInfo();
    this.openRoleDialog();
  }

  public getUserLoginInfo() {
    this.loginService.getLoginUser().subscribe((response) => {
      this.loadingState.loadSleepEnd(0.3);
      if (this.commonService.checkNoneResponse(response)) {
        this.loginService.logout(MESSAGE_CODE.E90000);
        return;
      } else {
        this.class_id = response.body.class_id;
        // 事務局の場合、なりすまし
        if (this.spoofId != '0') {
          this.class_id = this.spoofId;
        }
      }
    });
  }

  public openRoleDialog(): void {
    this.boardFlag = true;
  }

  public closeDialog(): void {
    this.boardFlag = false;
    this.returnStatusDialog.emit(this.boardFlag);
  }


  ngAfterViewInit() {
    this.getDetailTask();
  }

  public getDetailTask(): void {
    this.loadingState.loadStart(API_URL_GET_DETAIL_EVALUATION);
    
    this.dbOperationService
      .getNoTemplateDisplayData(API_URL_GET_DETAIL_EVALUATION, this.matchId + "?reportId=" + this.reportId)
      .subscribe((response) => {
        this.loadingState.loadSleepEnd(0.3, API_URL_GET_DETAIL_EVALUATION);

        if (this.commonService.checkInvalidValue(response)) {
          this.closeDialog();
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          )
          this.reload.emit();
          return;
        } else if (this.commonService.checkNoneResponse(response)) {
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );

          // this.location.back();
        } else {
          this.data.push(response.body);
        }
      });
  }

  public formatDateJapan(implementation_date: any) {
    let date = new Date(implementation_date);
    let lang = 'en',
      year = date.toLocaleString(lang, { year: 'numeric' }),
      month = date.toLocaleString(lang, { month: 'numeric' }),
      day = date.toLocaleString(lang, { day: 'numeric' });
    return `${year}年 ${month}月 ${day}日`;
  }
}
